export const dataFilter = {
  categories: [
    {
      name: 'Обувь',
      subcategories: [
        {
          name: 'Кроссовки',
          subcategories: [{ name: 'Беговые' }, { name: 'Повседневные' }, { name: 'Для тренировок' }],
        },
        {
          name: 'Ботинки',
          subcategories: [{ name: 'Зимние' }, { name: 'Осенние' }, { name: 'Треккинговые' }],
        },
        { name: 'Сандалии' },
        { name: 'Туфли' },
        { name: 'Кеды' },
      ],
    },
    {
      name: 'Одежда',
      subcategories: [{ name: 'Футболки' }, { name: 'Брюки' }, { name: 'Куртки' }],
    },
  ],
  brands: [
    { name: 'Nike', count: 150 },
    { name: 'Adidas', count: 120 },
    { name: 'Puma', count: 80 },
    { name: 'Reebok', count: 95 },
    { name: 'New Balance', count: 70 },
    { name: 'Asics', count: 60 },
    { name: 'Vans', count: 55 },
    { name: 'Converse', count: 65 },
    { name: 'Under Armour', count: 45 },
    { name: 'Skechers', count: 40 },
    { name: 'Fila', count: 35 },
    { name: 'Timberland', count: 30 },
    { name: 'Columbia', count: 25 },
    { name: 'The North Face', count: 20 },
    { name: 'Salomon', count: 15 },
  ],
  sizes: [
    { name: '36', count: 50 },
    { name: '37', count: 75 },
    { name: '38', count: 100 },
    { name: '39', count: 120 },
    { name: '40', count: 150 },
    { name: '41', count: 130 },
    { name: '42', count: 110 },
    { name: '43', count: 90 },
    { name: '44', count: 70 },
    { name: '45', count: 50 },
    { name: '46', count: 30 },
    { name: '47', count: 20 },
    { name: '35', count: 25 },
    { name: '48', count: 10 },
    { name: '34', count: 15 },
  ],
};
